import { render, staticRenderFns } from "./StudyDetail.vue?vue&type=template&id=59833a4e&"
import script from "./StudyDetail.vue?vue&type=script&lang=js&"
export * from "./StudyDetail.vue?vue&type=script&lang=js&"
import style0 from "./StudyDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports